import { render, staticRenderFns } from "./CrewCalculator.vue?vue&type=template&id=f75a2ed0&scoped=true&"
import script from "./CrewCalculator.vue?vue&type=script&lang=js&"
export * from "./CrewCalculator.vue?vue&type=script&lang=js&"
import style0 from "./CrewCalculator.vue?vue&type=style&index=0&id=f75a2ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75a2ed0",
  null
  
)

export default component.exports